module.exports = __webpack_public_path__ + "static/media/malpuri.015165b9.png";